import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { TabSessionService } from './core/services/tab-session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'mosaikus';

  constructor(
    private tabSessionService: TabSessionService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    const initResult = this.tabSessionService.consumeInitializationResult();
    if (!initResult?.cloneDetected) {
      return;
    }

    this.snackBar.open(
      'Abrimos uma nova sessão para esta aba. Selecione as posições novamente.',
      'Fechar',
      {
        duration: 5000,
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
      }
    );
  }
}
